import type {Author} from '../conversation-types'

export const VALUES = {
  ghostUser: {
    avatarUrl: 'https://avatars.githubusercontent.com/ghost',
    id: 'ghost',
    login: 'ghost',
    url: '/ghost',
    __typename: 'Author',
  } as Author,
}
